<label [ngClass]="wrap() ? '!flex-row w-full !gap-3' : 'flex-col'">
    @if (labelPosition() === "out") {
        @if (label(); as label) {
            <app-label [required]="required()">
                {{ label }}
            </app-label>
        }
    }
    @if (hint() && hint().length > 0) {
        <div class="flex flex-col gap-2">
            @for (hint of hint(); track $index) {
                <app-hint>{{ hint }}</app-hint>
            }
        </div>
    }

    <div
        [attr.data-size]="currentSize()"
        [attr.data-rounded]="currentRounded()"
        [attr.data-disabled]="disabled()"
        class="input-wrapper input-rounded input-padding w-full"
    >
        <div
            [attr.data-color]="currentColor()"
            [attr.data-rounded]="currentRounded()"
            class="input-outline input-rounded"
        ></div>
        <div class="flex flex-col w-full gap-1">
            @if (labelPosition() === "in") {
                <app-label [required]="required()">{{ label() }}</app-label>
            }
            <textarea
                [style.height]="height() + 'px'"
                class="theme-text !text-base"
                [placeholder]="placeholder()"
                [spellcheck]="spellcheck()"
                [autocomplete]="autocomplete()"
                [autofocus]="autofocus()"
                [readOnly]="readonly()"
                [maxLength]="maxlength() || 524288"
                [(ngModel)]="value"
            ></textarea>
        </div>
    </div>
</label>
